export const IS_BIO_DIESEL_SUITABLE = 'isBioDieselSuitable';
export const HAS_PADDLE_SHIFTERS = 'hasPaddleShifters';
export const HAS_RANGE_EXTENDER = 'hasrangeExtender';
export const HAS_WARRANTY = 'hasWarranty';
export const IS_NON_SMOKER_VEHICLE = 'isNonSmokerVehicle';
